import { render, staticRenderFns } from "./uploadBomFile.vue?vue&type=template&id=0b87898e"
import script from "./uploadBomFile.vue?vue&type=script&lang=js"
export * from "./uploadBomFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports